import {connect} from 'react-redux';
import ConfirmStatusChangeModal from './ConfirmStatusChangeModal.jsx';
import {cancelConfirmStatusChangeModal} from './actionTypes';
import {handleSetStatusClick} from './actions';

const mapStateToProps = state => state.tournament.status.confirmStatusChangeModal;

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(cancelConfirmStatusChangeModal()),
  onConfirmClick: (status) => dispatch(handleSetStatusClick(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmStatusChangeModal);



// WEBPACK FOOTER //
// ./src/features/tournament/status/ConfirmStatusChangeModalContainer.jsx